<script>
//GeneralMixins.vue
export default {
  computed: {
  },
  methods: {
    toCurrency (val) {
      return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(Math.round(val) / 100)
    },
    stripCurrency (val){
      return val.replace(/\D/g, '')
    }
  },
}
</script>
